import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Divider } from 'antd';
import React from 'react';
import "./nodatamessagecomponent.css";

const NoDataMessageComponent = ({text}) => {
  return (
    <Divider plain className='no-data-divider'><ExclamationCircleOutlined className='no-data-icon' />{text}</Divider>
  )
}

export default NoDataMessageComponent;